var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"basic-block block-mokuji",style:(_vm.styles)},[_c('div',{staticClass:"content-wrap"},[_c('div',{staticClass:"block-mokuji__inner"},[_c('div',{staticClass:"block-mokuji__title"},[_vm._v("もくじ")]),_vm._v(" "),_c('ul',{staticClass:"block-mokuji__list"},_vm._l((_vm.list),function(v,i){return _c('li',{key:i},[_vm._v(_vm._s(v))])}),0)])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e031c4d0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/recommend/lp/counselor/ottimo/blocks/BlockMokuji.vue
// module id = null
// module chunks = 